export default [
  {
    path: "/admin/login",
    name: "login",
    component: () => import("./pages/login.vue"),
    meta: {
      authPage: true, // Чтобы после авторизации нельзя было по ним перейти
      layout: "auth",
      title: "Вход",
    },
  },
  {
    path: "/admin/reset-password",
    name: "reset-password",
    component: () => import("./pages/reset.vue"),
    meta: {
      authPage: true, // Чтобы после авторизации нельзя было по ним перейти
      layout: "auth",
      title: "Сброс пароля",
    },
  },
];
